import { render, staticRenderFns } from "./routerMenuList.vue?vue&type=template&id=d3298432&scoped=true"
import script from "./routerMenuList.vue?vue&type=script&lang=js"
export * from "./routerMenuList.vue?vue&type=script&lang=js"
import style0 from "./routerMenuList.vue?vue&type=style&index=0&id=d3298432&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3298432",
  null
  
)

export default component.exports